import { db } from "../../utils/firebase";

export const getBiography = async () => {
    const biography = db.collection("about").doc("biography");
    const doc = await biography.get();
    const { bio, image, title, subtitle } = doc.data();

  return { bio, image, title, subtitle };
  }